import React from 'react';

import { Box, Text } from '@chakra-ui/react';

const InformationPerfil = ({ title, information, mt }) => {

  return (
    <Box
      display="block" 
      mt={mt ? mt : "15px"} 
    >
      <Text
        fontWeight={600}
        fontSize="14px"
        lineHeight="19.6px"
        color="#000"
      >
        {title}
      </Text>
      <Text
        as="div"
        fontWeight={500}
        fontSize="14px"
        lineHeight="19.6px"
        color="#6B6C71"
      >
        {information}
      </Text>
    </Box>
  );
}

export default InformationPerfil;